import PropTypes from 'prop-types'
import queryString from 'query-string'
import { Component } from 'react'

import agent from 'agent'
import BusyOverlay from 'components/common/BusyOverlay'
import { withAuthContext } from 'context/with-auth-context'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

class SAML extends Component {
  static propTypes = {
    location: PropTypes.object,
    history: PropTypes.object.isRequired,
    authState: PropTypes.object
  }

  async componentDidMount() {
    const { SamlSessionCode, RelayState } = queryString.parse(
      this.props.location.search
    )

    const handleError = (err) => {
      toast({
        type: 'error',
        text: messageFromResponseError(
          err,
          'Unable to authenticate using SAML. Please try again later.'
        )
      })

      this.props.history.push('/')
    }

    if (!SamlSessionCode.length || !RelayState.length) {
      handleError('parse-error')
      return
    }

    let res
    try {
      res = await agent.post('/users/auth/saml/sessions', {
        code: SamlSessionCode
      })
    } catch (err) {
      return handleError(err)
    }

    await this.props.authState.startSession(res.data)
    this.props.history.push(RelayState)
  }

  render() {
    return <BusyOverlay shown={true} text="Authorizing" />
  }
}

export default withAuthContext(SAML)
